// shims/react-use-usePrevious-default.js
import { useDebounce } from 'react-use';

export default useDebounce;
